import { MutationTree } from 'vuex'
import { Contact, ContactsState } from './contacts.types'

export enum MutationTypes {
  SET_CONTACTS = 'SET_CONTACTS',
  SET_CONTACT_GET_ERROR = 'SET_CONTACT_GET_ERROR'
}

export const mutations: MutationTree<ContactsState> = {
  [MutationTypes.SET_CONTACTS](state, contacts: Contact[]) {
    state.contacts = contacts
  }
}
